export default "__VITE_ASSET__DhKLyf83__"